/*
 * @Author: YH000644 weirongwei@danghuan.com
 * @Date: 2024-12-10 11:06:01
 * @LastEditors: YH000644 weirongwei@danghuan.com
 * @LastEditTime: 2024-12-10 14:32:15
 * @FilePath: \eu-eswop-official-site\src\services\api\home.js
 * @Description:
 */
import axios from '../axios'

const getEnumList = params => {
  return axios({
    url: '/customer/recycle/common/enum',
    method: 'get',
    params
  })
}
// 联系我们-发送邮箱
const contactUs = data => {
  return axios({
    url: '/customer/recycle/common/contact-us',
    method: 'post',
    data
  })
}
// 发送商务合作邮件
const businessContactUs = data => {
  return axios({
    url: '/customer/recycle/common/business/contact-us',
    method: 'post',
    data
  })
}

const getMobileAreaCode = params => {
  return axios({
    url: '/customer/recycle/common/mobileAreaCode',
    method: 'get',
    params
  })
}

// 发送商务合作邮件
const getBlogList = data => {
  return axios({
    url: '/customer/recycle/blog/pageList',
    method: 'post',
    data
  })
}

const getBlogDetail = params => {
  return axios({
    url: '/customer/recycle/blog/getDetail',
    method: 'get',
    params
  })
}







export {
  getEnumList,
  contactUs,
  businessContactUs,
  getMobileAreaCode,
  getBlogList,
  getBlogDetail
}
